import * as React from 'react';
import {memo, useContext} from "react";
import {ILocation} from "./VyberServisuPageContent";
import VyberServisuHeaderForm from "./VyberServisuHeaderForm";
import VyberServisuHeaderMapa from "./VyberServisuHeaderMapa";
import OpenFilterMenuButton from "./OpenFilterMenuButton";

type Props = {
    location?: ILocation;
}

const VyberServisuHeader : React.FC<Props> = () => {


    return (
        <div className={"vyber-servisu-page__wrapper__header"}>
            <OpenFilterMenuButton />
            <VyberServisuHeaderForm />
            <VyberServisuHeaderMapa />
        </div>
    )
}
export default memo(VyberServisuHeader);